module.exports = __webpack_public_path__ + "public/img/img_android_down_ru_2.15c405e6.png";